export default __webpack_public_path__ + "static/media/Managed-Services_CMSP.1d651281.mp4";